import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { listCitiesOptions } from '../../../features/cities/queries';
import { listEventCategoriesOptions } from '../../../features/event-categories/queries';
import { EventsFilters } from '../../../features/events/components/events-filters';
import { EventsTable } from '../../../features/events/components/events-table';
import { listEventsOptions } from '../../../features/events/queries';
import { PageHeader } from '../../../shared/components/page-header';
import { Route as EventsRoute } from './route';

export const Route = createFileRoute('/_authenticated/events/')({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(listCitiesOptions()),
      context.queryClient.ensureQueryData(listEventCategoriesOptions()),
    ]);
  },
  component: EventsIndexPage,
});

function EventsIndexPage() {
  const search = EventsRoute.useSearch();
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const { data: categories } = useSuspenseQuery(listEventCategoriesOptions());
  const { data: list } = useSuspenseQuery(listEventsOptions(search));

  return (
    <div>
      <PageHeader
        title="События"
        description="Список мероприятий по всем городам и статусам."
        actions={
          <Button asChild>
            <Link to="/events/new">Новое событие</Link>
          </Button>
        }
      />
      <EventsFilters
        cities={cities}
        categories={categories}
        value={{
          cityId: search.cityId,
          status: search.status,
          categoryId: search.categoryId,
          from: search.from,
          to: search.to,
          search: search.search,
        }}
      />
      <EventsTable
        events={list.items}
        cities={cities}
        nextCursor={list.nextCursor}
        currentCursor={search.cursor}
      />
    </div>
  );
}
